(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerGaleryCard', {
            templateUrl: 'app/components/flyer-galery-card/flyer-galery-card.html',
            controller: flyerGaleryCardController,
            bindings: {
                flyer: '<',
                bucket: '=',
                storeId: '=',
                currencyInstance: '<',
                checkboxIsChecked: '<',
                checkboxClick: '&',
                isPublished: '<',
                isRealStateMarket: '=',
                unpublishFlyer: '&',
                publishFlyer: '&',
                flyerActions: '<',
                erpIcon: '<'
            }
        });

    /** @ngInject */
    function flyerGaleryCardController($rootScope, $scope, $document, $translate, systemConstants) {

        var $ctrl = this;

        $ctrl.$onInit = init;

        function init() {

            $ctrl.formatedAddress = $ctrl.flyer.address ?
                $ctrl.flyer.address.street + ' - ' + $ctrl.flyer.address.city + ' - ' + $ctrl.flyer.address.state
                : "";

            var coverImageResolution = systemConstants.IMAGE_RESOLUTIONS.GALLERY_CARD;
            var groupedImage = getGroupedCoverImage($ctrl.flyer);

            if (groupedImage) {
                $ctrl.coverImage = groupedImage;
            } else {
                $ctrl.coverImage = $ctrl.isHubContext ?
                    getHubFlyerImageWithResolution($ctrl.flyer, coverImageResolution)
                    : getFlyerImageWithResolution($ctrl.flyer, coverImageResolution);
            }
        }

        function getMinMax(details, key) {
            var values = [];
            for (var i = 0; i < details.length; i++) {
                if (angular.isArray(key)) {
                    for (var j = 0; j < key.length; j++) {
                        var val = details[i][key[j]];
                        if (val !== undefined && val !== null) {
                            values.push(val);
                        }
                    }
                } else {
                    var v = details[i][key];
                    if (v !== undefined && v !== null) {
                        values.push(v);
                    }
                }
            }

            return values.length > 0 ? [Math.min.apply(null, values), Math.max.apply(null, values)] : [null, null];
        }

        $ctrl.getMinMaxPurchaseValue = function () {
            if (!$ctrl.flyer.details || $ctrl.flyer.details.length === 0) {
                $ctrl.hasDetails = false;
                return;
            }

            $ctrl.hasDetails = true;
            var details = $ctrl.flyer.details;
            $ctrl.singleItem = details.length === 1;

            var minMax = getMinMax(details, 'purchaseValue');
            if (!$ctrl.isRealStateMarket) {
                minMax = getMinMax(details, ['purchaseValue', 'discountedValue']);
            }
            $ctrl.minPurchaseValue = minMax[0];
            $ctrl.maxPurchaseValue = minMax[1];

            $ctrl.shouldShowSingleValue = $ctrl.singleItem || $ctrl.minPurchaseValue.toFixed(2) === $ctrl.maxPurchaseValue.toFixed(2);
        };

        $ctrl.getMinMaxPurchaseValue();
    }
})();
